module.exports = __webpack_public_path__ + "static/media/concrete-wall.2db627a2.jpg";